import { useState } from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CreateQuestionTemplateModal } from './CreateQuestionTemplate'
import { QuestionTemplatesTable } from './QuestionTemplatesTable'

interface Props {
  companyId: number
}

export const QuestionTemplates = ({ companyId }: Props) => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <>
      <Section
        illustration="document-edit"
        title={i18n.t('ats.settings.templates.custom_questions.title')}
        description={i18n.t('ats.settings.templates.custom_questions.description')}
        action={{
          onClick: () => setShowCreateModal(true),
          label: i18n.t('ats.settings.templates.custom_questions.new_question.action'),
        }}
      />
      <Box paddingX="s64" paddingBottom="s32">
        <QuestionTemplatesTable />
      </Box>

      {showCreateModal && (
        <CreateQuestionTemplateModal
          companyId={companyId}
          onClose={() => setShowCreateModal(false)}
        />
      )}
    </>
  )
}
